import { render, staticRenderFns } from "./BotFeaturesCheckboxGroup.vue?vue&type=template&id=331cf9a4"
import script from "./BotFeaturesCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./BotFeaturesCheckboxGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports